import { render, staticRenderFns } from "./AddStafferDialog.vue?vue&type=template&id=703e3121&scoped=true&"
import script from "./AddStafferDialog.vue?vue&type=script&lang=js&"
export * from "./AddStafferDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddStafferDialog.vue?vue&type=style&index=0&id=703e3121&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703e3121",
  null
  
)

export default component.exports